// extracted by mini-css-extract-plugin
module.exports = {"flexCenter":"FlexCenter_flexCenter__mQ4Zt"};